var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline center-xs" }, [
          _c("label", { attrs: { for: "general" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.filtro,
                  expression: "form.filtro"
                }
              ],
              attrs: {
                value: "G",
                type: "radio",
                name: "filtro",
                id: "general"
              },
              domProps: { checked: _vm._q(_vm.form.filtro, "G") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.form, "filtro", "G")
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("General")])
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "especifico" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.filtro,
                  expression: "form.filtro"
                }
              ],
              attrs: {
                value: "R",
                type: "radio",
                name: "filtro",
                id: "especifico"
              },
              domProps: { checked: _vm._q(_vm.form.filtro, "R") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.form, "filtro", "R")
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Por rango de fechas")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.filtro === "R",
                  expression: "form.filtro === 'R'"
                }
              ],
              staticClass: "form-field"
            },
            [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "desde",
                      label: "YYYY-MM-DD",
                      locale: "es",
                      "no-label": "",
                      "only-date": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD"
                    },
                    model: {
                      value: _vm.form.desde,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "desde", $$v)
                      },
                      expression: "form.desde"
                    }
                  }),
                  _vm._v(" "),
                  _vm.errores.desde
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.desde[0]))])]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.filtro === "R",
                  expression: "form.filtro === 'R'"
                }
              ],
              staticClass: "form-field"
            },
            [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "hasta",
                      label: "YYYY-MM-DD",
                      locale: "es",
                      "no-label": "",
                      "only-date": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD"
                    },
                    model: {
                      value: _vm.form.hasta,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "hasta", $$v)
                      },
                      expression: "form.hasta"
                    }
                  }),
                  _vm._v(" "),
                  _vm.errores.hasta
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.hasta[0]))])]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("span", [_vm._v("Consultar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipo === "N",
            expression: "tipo === 'N'"
          }
        ],
        staticClass: "row"
      },
      [
        _c("div", { staticClass: "col-xs-12" }, [
          _c(
            "div",
            { staticClass: "grid grid--fit" },
            [
              _c(
                "button-card",
                {
                  attrs: {
                    "btn-color": "btn-secondary",
                    "fa-name": "fa-check",
                    counter: _vm.consultasExitosas
                  }
                },
                [_vm._v("Consultas exitosas")]
              ),
              _vm._v(" "),
              _c(
                "button-card",
                {
                  attrs: {
                    prefix: "$ ",
                    "btn-color": "btn-info",
                    "fa-name": "fa-money",
                    counter: _vm.ingresosPorConsultas
                  }
                },
                [_vm._v("Ingresos por consultas")]
              ),
              _vm._v(" "),
              _c(
                "button-card",
                {
                  attrs: {
                    "btn-color": "btn-success",
                    prefix: "$ ",
                    "fa-name": "fa-balance-scale",
                    counter: _vm.margenGanancias
                  }
                },
                [_vm._v("Margen de ganancias")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12" }, [
          _c(
            "div",
            { staticClass: "grid grid--fit" },
            [
              _c(
                "button-card",
                {
                  attrs: {
                    "btn-color": "btn-danger",
                    prefix: "$ ",
                    "fa-name": "fa-undo",
                    counter: _vm.devolucionesConsultas
                  }
                },
                [_vm._v("Devoluciones de consultas")]
              ),
              _vm._v(" "),
              _c(
                "button-card",
                {
                  attrs: {
                    "btn-color": "btn-primary",
                    "fa-name": "fa-user-md",
                    counter: _vm.totalDoctores
                  }
                },
                [_vm._v("Médicos totales")]
              ),
              _vm._v(" "),
              _c(
                "button-card",
                {
                  attrs: {
                    "btn-color": "btn-dark",
                    "fa-name": "fa-users",
                    counter: _vm.totalPacientes
                  }
                },
                [_vm._v("Pacientes totales")]
              )
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipo === "N",
            expression: "tipo === 'N'"
          }
        ],
        staticClass: "row mt-2"
      },
      [
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [_c("pie-chart", { attrs: { data: _vm.consultasGenerales } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [_c("bar-chart", { attrs: { data: _vm.doctoresTop } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [_c("bar-chart", { attrs: { data: _vm.pacientesTop } })],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipo === "N",
            expression: "tipo === 'N'"
          }
        ],
        staticClass: "row mt-4"
      },
      [
        _c("div", { staticClass: "col-xs-12" }, [
          _c(
            "div",
            { staticClass: "grid grid--fit" },
            [
              _c(
                "button-card",
                {
                  attrs: {
                    prefix: "$ ",
                    "btn-color": "btn-warning",
                    "fa-name": "fa-minus-square",
                    counter: _vm.cuentasPagar
                  }
                },
                [_vm._v("Cuentas por pagar")]
              ),
              _vm._v(" "),
              _c(
                "button-card",
                {
                  attrs: {
                    prefix: "$ ",
                    "btn-color": "btn-bus200",
                    "fa-name": "fa-minus",
                    counter: _vm.totalPagadoDoctor
                  }
                },
                [_vm._v("Total pagado a médicos")]
              ),
              _vm._v(" "),
              _c(
                "button-card",
                {
                  attrs: {
                    "btn-color": "btn-bus300",
                    prefix: "$ ",
                    "fa-name": "fa-university",
                    counter: _vm.totalComisionBancos
                  }
                },
                [_vm._v("Total de comisiones de bancos")]
              )
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__title" }, [
            _c("h5", [
              _vm._v(
                "Consultas por médico " +
                  _vm._s(
                    _vm.selectedDoctor !== null
                      ? "- " + _vm.selectedDoctor.nombre_cabecera
                      : ""
                  )
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.doctores.length > 1,
                    expression: "doctores.length > 1"
                  }
                ],
                staticClass: "card__controls"
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field select2-field--stretch" },
                    [
                      _c("v-select", {
                        attrs: {
                          id: "doctor",
                          placeholder: "Seleccione un médico...",
                          options: _vm.doctores,
                          label: "nombre_cabecera"
                        },
                        on: { input: _vm.consultarDoctor },
                        model: {
                          value: _vm.selectedDoctor,
                          callback: function($$v) {
                            _vm.selectedDoctor = $$v
                          },
                          expression: "selectedDoctor"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "doctor" } }, [
                        _vm._v("Médico")
                      ]),
                      _vm._v(" "),
                      _vm.errores.doctor_id
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.doctor_id[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.doctor_id !== "",
                    expression: "form.doctor_id !== ''"
                  }
                ],
                staticClass: "row"
              },
              [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-md-4" },
                  [_c("pie-chart", { attrs: { data: _vm.consultasDoctor } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12",
                    class: {
                      "col-md-8": _vm.tipo === "N",
                      "col-md-4": _vm.tipo !== "N"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "grid grid--fit" },
                      [
                        _c(
                          "button-card",
                          {
                            attrs: {
                              prefix: "$ ",
                              "btn-color": "btn-warning",
                              "fa-name": "fa-minus-square",
                              counter: _vm.cuentasPagarDoctor
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.tipo === "N"
                                  ? "Cuentas por pagar"
                                  : "Cuentas por cobrar"
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.tipo === "N"
                          ? _c(
                              "button-card",
                              {
                                attrs: {
                                  prefix: "$ ",
                                  "btn-color": "btn-bus200",
                                  "fa-name": "fa-minus",
                                  counter: _vm.totalPagadoDoctorDoctor
                                }
                              },
                              [_vm._v("Total pagado")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tipo === "N"
                          ? _c(
                              "button-card",
                              {
                                attrs: {
                                  "btn-color": "btn-bus300",
                                  prefix: "$ ",
                                  "fa-name": "fa-university",
                                  counter: _vm.totalComisionBancosDoctor
                                }
                              },
                              [_vm._v("Total de comisiones de bancos")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tipo === "N"
                          ? _c(
                              "button-card",
                              {
                                attrs: {
                                  "btn-color": "btn-success",
                                  "fa-name": "fa-balance-scale",
                                  prefix: "$ ",
                                  counter: _vm.margenGananciasDoctor
                                }
                              },
                              [_vm._v("Margen de ganancias")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.doctor_id === "",
                    expression: "form.doctor_id === ''"
                  }
                ],
                staticClass: "row"
              },
              [_vm._m(4)]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipo === "N",
            expression: "tipo === 'N'"
          }
        ],
        staticClass: "row mt-4"
      },
      [
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("pie-chart", {
                  attrs: { data: _vm.consultasTarjetasCredito }
                })
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Dashboard")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Consultas")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Top 10 de médicos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Top 10 de pacientes")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("p", [_vm._v("Debe seleccionar un médico.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Tarjetas por consultas")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48d34360", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d34360","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/KDashboard.vue
// module id = 609
// module chunks = 0